import { autoGeneratedReducer } from '@hh.ru/redux-create-reducer';

const employerManagersName = autoGeneratedReducer<Record<string, string>>(null);
export { employerManagersName };
